<template>
    <footer :class="classList" style="margin-top: 10px">
        <slot>
            <div style="padding-left: 50px">
                <a href="https://www.ikomm.no">
                    <img
                        class="navbar-brand-minimized"
                        src="/img/brand/ikomm-logo.svg"
                        width="100"
                        height="50"
                        alt="Ikomm"
                    />
                </a>
            </div>
            <!-- <div class="ml-auto ">
				<a href="https://www.ikomm.no/privacy-policy/" v-if="true">Privacy Policy</a>
				&nbsp;
				<span ></span>
			</div> -->
        </slot>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter',
    props: {
        fixed: {
            type: Boolean,
            default: false,
        },
    },
    mounted: function() {
        this.isFixed()
    },
    computed: {
        classList() {
            return ['app-footer']
        },
    },
    methods: {
        isFixed() {
            this.fixed
                ? document.body.classList.add('footer-fixed')
                : document.body.classList.remove('footer-fixed')
        },
    },
}
</script>
